import M from 'materialize-css/dist/js/materialize';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, Button, Input, Label, SelectUnit } from '../../../components/UI/ComponentsUI';
import ConfigurationService from '../../../services/ConfigurationService';
import RoutePickingService from '../../../services/RoutePickingService';
import { getVision } from '../../../services/auth';
import { VISIONS } from '../../../utils/constants';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { formatData, getUserNameToName, isNullOrEmpty, makeEnum, translate, updateTextFields } from '../../../utils/util';

const PickingRouteInsert = (props) => {
    const update = props.location?.state?.update;
    const routeType = props.history?.location?.state?.routeType;
    const eTypeAlert = {
        Blue:
        {
            typeAlertId: 1,
            color: '#0000FF',
            text: 'Azul',
            quantity: undefined,
            time: undefined
        },
        Yellow: {
            typeAlertId: 2,
            color: '#FFD700',
            text: 'Amarelo',
            quantity: undefined,
            time: undefined
        },
        Red: {
            typeAlertId: 3,
            color: '#FF0000',
            text: 'Vermelho',
            quantity: undefined,
            time: undefined
        }
    };

    const [pickingRoute, setPickingRoute] = useState(update ? {
        ...props.route,
        filterByArea: props.route?.areasId && props.route?.areasId.length > 0
    } : { readQrcode: true, dynamicFlow: true, filterByArea: false, type: routeType });
    const [alertRoute, setAlertRoute] = useState([]);

    useEffect(() => {
        if (update && props.route?.areasId && props.route?.areasId.length > 0) {
            pickingRoute.filterByArea = true;
            setPickingRoute({ ...pickingRoute });
        }
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, pickingRoute, setPickingRoute);
    };

    const onChangeArea = (event) => {
        const selectedOptions = event.currentTarget.selectedOptions;
        if (selectedOptions.length > 0) {
            let finalFilter = {};
            Object.assign(finalFilter, pickingRoute);
            finalFilter.areasId = Array.from(selectedOptions).map(x => parseInt(x.value))
            setPickingRoute(finalFilter);
        }
    };

    const onChangeAlert = (event, typeAlertId, key) => {
        alertRoute.find(f => f.typeAlertId === typeAlertId)[key] = event.currentTarget.value;
        setAlertRoute(alertRoute);
    };

    const redirect = () => {
        props.history.goBack()
    }

    const onConfirm = () => {
        if (validateInputsRequired("formRoute")) {
            pickingRoute.alerts = alertRoute;
            if (update) {
                props.updateRoute(pickingRoute, () => {
                    redirect();
                });
            } else {
                props.addRoute(pickingRoute, () => {
                    redirect();
                });
            }
        }
    };

    useEffect(() => {
        if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            props.getResources(props.user.vision, {});
            if (update && props.route.alerts?.length > 0) {
                const alertUpdate = makeEnum(eTypeAlert);
                alertUpdate.forEach(alert => {
                    const item = props.route.alerts.find(f => f.typeAlertId === alert.typeAlertId);
                    if (item) {
                        alert.routeId = item.routeId;
                        alert.time = item.time;
                        alert.quantity = item.quantity;
                    }
                });
                setAlertRoute(alertUpdate);
            } else {
                setAlertRoute(makeEnum(eTypeAlert));
            }
        }
        updateTextFields();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        updateTextFields();
        M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
    }, [alertRoute, alertRoute.length]);

    const validadeDisableCode = () => {
        if (!isNullOrEmpty(pickingRoute?.code)) {
            return pickingRoute?.code.includes(translate("route-picking:partial-material"));
        }
        return false;
    }



    return (
        <div>
            <Breadcrumbs id="printInsert" title={{ icon: "mdi mdi-map-marker-path", label: translate('route', 'route-picking') }} subtitles={
                [{ icon: "mdi mdi-plus-box-outline", label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }]} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="formRoute">
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input onChange={onChange} required label={translate("fields.code", "route-picking")} id="code" name="code" type="text" defaultValue={pickingRoute?.code} disabled={validadeDisableCode()} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input onChange={onChange} required label={translate("fields.maxQuantity", "route-picking")} id="minQuantity" name="minQuantity" type="number" defaultValue={pickingRoute?.minQuantity} />
                                    </div>
                                    {(getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                                        <>
                                            <div className="input-field no-padding col s12">
                                                <Input onChange={onChange} required label={translate("fields.firingTime", "route-picking")} id="firingTime" name="firingTime" type="number" defaultValue={pickingRoute?.firingTime} />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input
                                                    type="checkbox"
                                                    label={translate("fields.partial", "route-picking")}
                                                    onChange={onChange}
                                                    defaultChecked={pickingRoute?.partial}
                                                    id="partial"
                                                    name="partial"
                                                />
                                            </div>
                                        </>)
                                    }
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            type="checkbox"
                                            label={translate("fields.dynamicFlow", "route-picking")}
                                            onChange={onChange}
                                            defaultChecked={pickingRoute?.dynamicFlow}
                                            id="dynamicFlow"
                                            name="dynamicFlow"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            type="checkbox"
                                            label={translate("fields.readQrcode", "route-picking")}
                                            onChange={onChange}
                                            defaultChecked={pickingRoute?.readQrcode}
                                            id="readQrcode"
                                            name="readQrcode"
                                        />
                                    </div>

                                    <div className="input-field no-padding col s12">
                                        <Input
                                            type="checkbox"
                                            label={translate("fields.filterByArea", "route-picking")}
                                            onChange={(evt) => {
                                                if (!evt.target.checked) {
                                                    pickingRoute.areasId = null;
                                                    pickingRoute.filterByArea = false;
                                                    setPickingRoute({ ...pickingRoute })
                                                } else {
                                                    onChange(evt);
                                                }
                                            }}
                                            defaultChecked={pickingRoute?.filterByArea}
                                            id="filterByArea"
                                            name="filterByArea"
                                        />
                                    </div>
                                    {
                                        pickingRoute.filterByArea &&
                                        <div className="input-field col s12">
                                            <SelectUnit
                                                id="areas"
                                                name="areas"
                                                valueId={true}
                                                multiple={true}
                                                required
                                                defaultValue={pickingRoute?.areasId}
                                                full={true}
                                                notOption={true}
                                                change={onChangeArea}
                                            />
                                        </div>

                                    }

                                    <div className="input-field no-padding col s12">
                                        <Input
                                            type="checkbox"
                                            label={translate("fields.show-in-filter-queue", "route-picking")}
                                            onChange={onChange}
                                            defaultChecked={pickingRoute?.showInFilterQueue}
                                            id="showInFilterQueue"
                                            name="showInFilterQueue"
                                        />
                                    </div>

                                    {update &&
                                        <div className="row" style={{ marginBottom: '0px' }}>
                                            <Label label={translate("fields.updateOn", "route-picking")} id="updatedOn" value={formatData(pickingRoute?.updatedOn)} />
                                            <Label label={translate("fields.updateBy", "route-picking")} id="updatedBy" value={getUserNameToName(props?.usersFromElog, pickingRoute?.updatedBy)} />
                                        </div>
                                    }
                                </div>
                                {
                                    (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                                        <div style={{ paddingTop: "10px" }}>
                                            <legend style={{ padding: "0 5px" }}>
                                                Kanban
                                            </legend>
                                            <ul className="collapsible">
                                                {
                                                    alertRoute.length > 0 && alertRoute.map((f, index) => (
                                                        <li key={`${f.key}-${index}`}>
                                                            <div className="collapsible-header">
                                                                <i className="mdi mdi-camera-timer" style={{ color: f.color }} />
                                                                {f.text}
                                                            </div>
                                                            <div className="collapsible-body">
                                                                <div key={`camp-${index}-${f.typeAlertId}`} className="input-field no-padding col s12">
                                                                    <Input id={`camp-${index}-${f.typeAlertId}`} min='0' defaultValue={f.time} onChange={(el) => onChangeAlert(el, f.typeAlertId, 'time')} label={translate("time", "route-picking")} name='time' type="number" />
                                                                </div>
                                                                <div key={`camp1-${index}-${f.typeAlertId}`} className="input-field no-padding col s12">
                                                                    <Input id={`camp1-${index}-${f.typeAlertId}`} min='0' defaultValue={f.quantity} onChange={(el) => onChangeAlert(el, f.typeAlertId, 'quantity')} label={translate("quantity", "route-picking")} name='quantity' type="number" />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    )
                                }
                            </form>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        route: state.pickingReducer.route,
        resource: state.configReducer.resources,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addRoute: (route, callback) => {
            dispatch(RoutePickingService.addRoute(route, callback));
        },
        updateRoute: (route, callback) => {
            dispatch(RoutePickingService.updateRoute(route, callback));
        },
        getResources: (vision, filter) => {
            dispatch(ConfigurationService.getResources(vision, filter));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingRouteInsert)));
